import Controller from "./settings.controller";
import template from "./settings.html";

const settings = {
  template,
  controller: Controller,
};

export default settings;



// WEBPACK FOOTER //
// ./src/pages/settings/settings.component.js